import { AppState, history } from 'src';
import { connect, Dispatch } from 'react-redux';
import { ContractDetailsProperties, ContractDetailsComponent } from './contract-details.component';
import {
  getContractDetails,
  searchCommentsByContract,
  selectComment,
  saveContractFiles,
  removeContractFile,
  updateContract,
  getRenewalContract,
  sendRenewalNotice,
  suspendContract,
  resumeContract,
  verify,
  updateCoe,
  setUSPSStatus,
  setShouldClear
} from 'src/contract/contract.actions';
import { loadBuyer, loadSeller, clearContractDetails } from 'src/contract/contract.actions';
import { ModalProps } from '@common/components';
import { toggleModal, getById } from '@common/components/common.actions';

import { FileViewModel } from '@models/Document';
import {
  loadContractInfoForResale,
  getContractResaleData,
  clearResaleData,
  setResaleLoading
} from 'src/contract/contract-resale.actions';
import { CustomerViewModel } from '@models/Customer';
import { getCustomerFromService } from 'src/customer/customer.actions';
import {
  getServiceWorkOrderContract,
  getServiceWorkOrderContractCVI
} from 'src/service-work-order/service-work-order.actions';
import { getRoute, RouteDefinitions } from '@common/route-definitions';
/*
This is the container for the component.
This "connects" the redux and react layers by translating the state of the page into props for the component.
It also wires up the actions so the component can emit them.
*/

// This is used to translate the state of the page to the props on the component
function mapStateToProps(state: AppState): Partial<ContractDetailsProperties> {
  return {
    contractDetailsVM: state.contract.contractDetailsVM!,
    commentsQuery: state.contract.commentsQuery,
    commentsLoading: state.contract.commentsLoading,
    commentsPageCount: state.contract.commentsPageCount,
    commentsPageNumber: state.contract.commentsPageNumber,
    commentsPageSize: state.contract.commentsPageSize,
    commentsResults: state.contract.commentsResults,
    selectedCommentText: state.contract.selectedCommentText,
    documents: state.contract.documents,
    contractResaleModalVM: state.contract.contractResaleModalVM,
    isOpenContract: state.contract.isOpenContract,
    isSavingUSPS: state.contract.isSavingUSPS,
    shouldClear: state.contract.shouldClear
  };
}

// This should create proxy wrappers for actions used by the component
function mapDispatchToProps(dispatch: Dispatch<AppState>): Partial<ContractDetailsProperties> {
  return {
    updateContract: (id: number, date: Date) => {
      dispatch(updateContract(id, { estimatedCoeDate: date })).then(() =>
        history.push(getRoute(RouteDefinitions.contract.Emails, { id: id }))
      );
    },
    updateCoe: (id: number, date: Date) => {
      dispatch(updateCoe(id, date))
        .then(() => dispatch(clearContractDetails()))
        .then(() => dispatch(getContractDetails(id)));
    },
    checkResale: (id: number, date: Date) => {
      const setPriceAdjustment = false;
      const isEdit = true;
      return dispatch(getContractResaleData(id, date, setPriceAdjustment, isEdit));
    },
    updateSellers: (id: number, date: Date) => {
      dispatch(updateContract(id, { sellerCoverageEndDate: date })).then(() => {
        dispatch(toggleModal());
        history.push(getRoute(RouteDefinitions.contract.Emails, { id: id }));
      });
    },
    getContractDetails: (id: number) => {
      dispatch(getContractDetails(id));
    },
    getCommentsByContract: (contractId, pageNumber, pageSize, query, filterBy) =>
      dispatch(searchCommentsByContract(contractId, pageNumber, pageSize, query)),
    selectComment: (commentText: string) => dispatch(selectComment(commentText)),
    toggleModal: (modalProps: ModalProps) => {
      dispatch(toggleModal(modalProps));
    },
    onBuyerCustomerSelect: (model: string, value: number) => {
      dispatch(getById<CustomerViewModel>(value, getCustomerFromService)).then(customer => {
        if (!customer) {
          return;
        }
        dispatch(loadBuyer(customer));
      });
    },
    onSellerCustomerSelect: (model: string, value: number) => {
      dispatch(getById<CustomerViewModel>(value, getCustomerFromService)).then(customer => {
        if (!customer) {
          return;
        }
        dispatch(loadSeller(customer));
      });
    },
    loadContractInfoForResale: async (id: number, premium: number, resaleDate: Date) => {
      dispatch(setResaleLoading(true));
      await dispatch(loadContractInfoForResale(id, premium, resaleDate));
      dispatch(setResaleLoading(false));
    },
    uploadFiles: (contractId: number, fileVMs: FileViewModel[]) => dispatch(saveContractFiles(contractId, fileVMs)),
    removeFile: (contractId: number, fileId: number) => dispatch(removeContractFile(contractId, fileId)),
    getRenewalContract: (contractId: number) => dispatch(getRenewalContract(contractId)),
    getContractResaleData: (id: number) => dispatch(getContractResaleData(id)),
    clearResaleData: () => dispatch(clearResaleData()),
    sendRenewalNotice: (contractId: number) => dispatch(sendRenewalNotice(contractId)),
    getServiceWorkOrderContract: (contractId: number) => {
      dispatch(getServiceWorkOrderContract(contractId));
      dispatch(getServiceWorkOrderContractCVI(contractId));
    },
    suspendContract: (contractId: number) => dispatch(suspendContract(contractId)),
    resumeContract: (contractId: number) => dispatch(resumeContract(contractId)),
    verify: (contractId: number) => dispatch(verify(contractId)),
    clearContractDetails: () => dispatch(clearContractDetails()),
    setUSPSStatus: (contractId: number, uspsStatus: number) => dispatch(setUSPSStatus(contractId, uspsStatus)),
    setShouldClear: (shouldClear: boolean) => dispatch(setShouldClear(shouldClear))
  };
}

// Connect function "wires" both of the map functions and returns a wrapper container for the component
export const ContractDetails = connect(
  mapStateToProps,
  mapDispatchToProps
)(ContractDetailsComponent);



// WEBPACK FOOTER //
// ./src/contract/_components/contract-details/contract-details.container.ts